import React from 'react';

import { Layout } from 'components/grid';

export const AuthCheck = () => <Layout.App />;
